export default __webpack_public_path__ + "static/media/EM1460.34I-37470_-22092_0.2a87dc3e.jpg";